// frontend_MainDashboard/src/firebase.ts
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// IMPORTANT: Paste your actual Firebase project's web app config here!
const firebaseConfig = {
    apiKey: "AIzaSyCOhVC1HD76VeibSJPx_Hqm6tAEJPhSJp4",
    authDomain: "openmirrorchatbot.firebaseapp.com",
    projectId: "openmirrorchatbot",
    storageBucket: "openmirrorchatbot.firebasestorage.app",
    messagingSenderId: "708857672554",
    appId: "1:708857672554:web:d5a6bf26506ad9306f6b13",
    measurementId: "G-777T86BK4F"
  };

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app); // Export the auth instance
export const db = getFirestore(app); // Initialize and export Firestore
export default app; // Export the firebase app instance